import MainPracticeScenario from './MainPracticeScenario';
import { constants, Globals } from '../../../../misc/helpers';
import { ScenarioEndType, ScenarioSceneType, StepToSkip } from '../../../../misc/BleedingControlScenario';

export default class MainPracticeScenarioSteps7And8 {
	constructor(private mainScenario: MainPracticeScenario, private onDone: () => void, public showFailedAar: () => void) {
	}

	public timeRanOut : void;
	start() {
		this.step1ShowBleedingControlKit();
	}

	private step1ShowBleedingControlKit() {
		var context = this;
		this.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.BleedoutTimer, {
			dispatch: this.mainScenario.gameManager.customData.dispatch,
			onTimeRanOut: () => {
				this.showFailedAar();
			},
			isActive: true
		});

		this.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.BleedoutTimer, {
			dispatch: this.mainScenario.gameManager.customData.dispatch,
			onTimeRanOut: () => {
				this.showFailedAar();
			},
			isActive: true
		});
		context.mainScenario.gameManager.UiManager.hideaAllUis();
		context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.Feedback, {message: 'Open the bleeding control kit and select the tourniquet.'});
		context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.BleedingControlKit, {
			onSelectionChanged: (index: number) => {
				if (!context.mainScenario.gameManager || !context.mainScenario.gameManager.UiManager) {
					return;
				}
				if (index === 1) {
					context.step2TourniqueteSelected();
				} else {
					context.step2TourniqueteNotSelected();
				}
			}
		});
	}

	private step2TourniqueteSelected() {
		var context = this;
		context.mainScenario.gameManager.UiManager.hideaAllUis();
		this.step3PlaceTourniqueteAboveWound();
		context.mainScenario.playSound('Step-8', '3', () => {
			context.mainScenario.playSound('Step-8', '4', () => {
			});
		});
	}
	private step2TourniqueteNotSelected() {
		var context = this;
		context.mainScenario.gameManager.UiManager.hideaAllUis();
		this.mainScenario.showJITFeedback('This choice is incorrect', () => context.step1ShowBleedingControlKit());
	}

	private step3PlaceTourniqueteAboveWound() {
		var context = this;
		context.mainScenario.gameManager.UiManager.showSingleUi(constants.InGameUINames.BinaryQuestion, {
			title: 'Would you like to apply the tourniquet above the wound?',
			correctButton: {
				title: 'Yes',
				onClick: () => context.mainScenario.onAnsweredCorrectly('MainPracticeScenarioSteps7And8.step3PlaceTourniqueteAboveWound', () => context.step3PlaceTourniqueteAboveWoundYes())
			},
			incorrectButton: {
				title: 'No',
				onClick: () => context.step3PlaceTourniqueteAboveWoundNo()
			}
		});
	}

	private step3PlaceTourniqueteAboveWoundYes() {
		var context = this;
		context.mainScenario.gameManager.UiManager.hideaAllUis();
		this.mainScenario.aarApplyFirstTourniquete = true;
		this.mainScenario.aarPDScenarioD = true;
		if(this.mainScenario.scenarioSceneToLoad === ScenarioSceneType.scenarioD && this.mainScenario.endAt !== ScenarioEndType.firstTourniquete) {
			context.mainScenario.gameManager.UiManager.hideaAllUis();
		}
		else {
			context.mainScenario.playSequence('ApplyPressureEnd', null, ()=> {
			});
		}
		this.step4TourniqueteInteraction();
		this.mainScenario.playSound('Step-8', '1', () => {
			context.mainScenario.playSequence('VictimPlayLips');

			this.mainScenario.playSound('Step-8', '2', () => {
				context.mainScenario.playSequence('VictimStopLips');
			});
		});
	}
	private step3PlaceTourniqueteAboveWoundNo() {
		var context = this;
		this.mainScenario.showJITFeedback('This choice is incorrect', () => context.step3PlaceTourniqueteAboveWound());
	}

	private step4TourniqueteInteraction() {
		var context = this;
		this.mainScenario.gameManager.UiManager.hideaAllUis();
		Globals.stopTimer = false;
		context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.Feedback, {message: 'Drag the tourniquet to the correct location. KB - Tab to cycle placements, use spacebar to select the location.'});
		this.mainScenario.playSequence('TourniqueteSetup', null, () => {
			context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.TourniquetePlacement, {
				dispatch: this.mainScenario.gameManager.customData.dispatch,
				locations: this.mainScenario.locations,
				correctIndex1: context.mainScenario.correctT1,
				wrongIndex: context.mainScenario.wrongT1,
				closeIndex: context.mainScenario.closeT1,
				isPractice: true,
				isSceneA: context.mainScenario.SceneAT,
				isSceneB: context.mainScenario.SceneBT,
				isSceneC: context.mainScenario.SceneCT,
				isSceneD: context.mainScenario.SceneDT,
				onDone: (selectedNumber: number, isCorrect: boolean) => {
					context.mainScenario.selectedTourniquetIndex = selectedNumber;

					if (isCorrect) {
						context.step4TourniqueteInteractionCorrect();
					} else {
						context.step4TourniqueteInteractionIncorrect();
					}
				}
			});
		});
	}

	private step4TourniqueteInteractionCorrect() {
		var context = this;
		context.mainScenario.gameManager.UiManager.hideaAllUis();
		//context.mainScenario.playSequence('Steps7And8Cinematic', null, () => {
			context.onDone();
		//});
	}
	private step4TourniqueteInteractionIncorrect() {
		var context = this;
		context.mainScenario.gameManager.UiManager.hideaAllUis();
		this.mainScenario.showJITFeedback('This choice is incorrect', () => context.step4TourniqueteInteraction());
	}
}